import { Component, OnInit, input, output, signal, ChangeDetectionStrategy } from '@angular/core';
import { MenuService } from '../menu.service';
import { Menu } from '../menu.model';
import { Subscription } from 'rxjs';
import { AuthenticationService } from '../../../../services/AuthenticationService';
import { AppService } from '../../../../app.service';
import { AppConfig } from '../../../../app.config';

@Component({ standalone: false,
  selector: 'app-vertical-menu',
  templateUrl: './vertical-menu.component.html',
  styleUrls: ['./vertical-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  providers: [ MenuService ]
})
export class VerticalMenuComponent implements OnInit {
  readonly menuParentId = input<number|undefined>(undefined);
  readonly routerLinkSelected = output<any>();
  public menuItems?: Array<Menu>;
  public readonly expandedMenuId = signal<number|undefined>(undefined);

  private refreshMenuSubscription:Subscription;

  constructor(public menuService:MenuService, private authService:AuthenticationService, private appService:AppService, private appConfig:AppConfig) {
    this.refreshMenuSubscription = this.menuService.refreshMenuSubject.subscribe(()=>{
      this.loadMenuItems();
    });
  }

  ngOnInit() {
    this.loadMenuItems();
  }

  ngOnDestroy(){
    if(this.refreshMenuSubscription) this.refreshMenuSubscription.unsubscribe();
  }

  private loadMenuItems(){
    this.menuItems = this.menuService.getVerticalMenuItems();
    this.menuItems = this.menuItems.filter(item => item.parentId == this.menuParentId() && !item.hidden);
  }

  onClick(menu:Menu){
    //only one sibling sub menu is open at a time
    if(menu.hasSubMenu) this.expandedMenuId.update(id => id === menu.id ? undefined : menu.id);
    else this.expandedMenuId.set(undefined);
    if(menu.routerLink) this.routerLinkSelected.emit(undefined);
  }

  get authenticated(){
    return this.authService.authenticated;
  }

  get isSuperAdmin(){
    return this.authService.currentUserValue?.role=='SuperAdmin';
  }

  get compareVisible(){
    return this.appConfig.compareVisible;
  }

  get favoriteProperties(){
    return this.appService.favoriteProperties;
  }

  get comparableProperties(){
    return this.appService.compareProperties;
  }

}
